import React from 'react'


export default function WarnTooltip(props) {
    return <div id={props.id} className='warn-tooltip invisible'>
        Предыдущий расчет был изменен. Необходимо пересчитать этот расчет!
    </div>;
}
